module.exports = __webpack_public_path__ + "static/media/8785.92674c69.png";